import { ruleRunner } from 'validations/ruleRunner';
import { required, isEmail } from 'validations/rules';

const Validations = [ruleRunner('email', 'e-mail', required, isEmail)];

export default Validations;
